import { concat, fn } from '@ember/helper';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import perform from 'ember-concurrency/helpers/perform';
import { t } from 'ember-intl';
import type { Signature as TaskDropdownSig } from 'parog-web/components/planning-board/tasks-table/task-dropdown';
import tWithDefault from 'parog-web/helpers/t-with-default';
import transitionToForc from 'parog-web/helpers/transition-to-forc';
import type TaskPlannedJournalEvent from 'parog-web/models/task-planned-journal-event';

interface Signature {
  Args: {
    task: TaskPlannedJournalEvent;
    shouldHideShiftOther?: boolean;
    dropdown: TaskDropdownSig['Blocks']['default'][0];
    onTaskProcessedOrShifted?: () => void;
  };
}

export default class TaskDropdownItemsComponent extends Component<Signature> {
  get taskActions() {
    if (this.args.task.taskType === 'measurement-received') {
      return [
        'made-without-patient-call',
        'made-with-patient-call',
        'irrelevant'
      ];
    }

    return ['completed', 'not-completed', 'irrelevant'];
  }

  processTask = task(async (task, actionTaken) => {
    this.args.onTaskProcessedOrShifted?.();
    await task.processTask(actionTaken);
  });

  shiftTask = task(async (task, unit) => {
    await task.shift(1, unit);
    this.args.onTaskProcessedOrShifted?.();
  });

  <template>
    {{#each this.taskActions as |actionTaken|}}
      <@dropdown.Item
        @onClick={{fn (perform this.processTask) @task actionTaken}}
        @key={{actionTaken}}
      >
        {{tWithDefault (concat 'task.actions.' actionTaken) actionTaken}}
      </@dropdown.Item>
    {{/each}}

    <@dropdown.Divider />

    <@dropdown.Item
      @onClick={{fn (perform this.shiftTask) @task 'days'}}
      @key='shift-day'
    >
      {{t 'task.actions.shift-day'}}
    </@dropdown.Item>
    <@dropdown.Item
      @onClick={{fn (perform this.shiftTask) @task 'weeks'}}
      @key='shift-week'
    >
      {{t 'task.actions.shift-week'}}
    </@dropdown.Item>
    <@dropdown.Item
      @onClick={{fn (perform this.shiftTask) @task 'months'}}
      @key='shift-month'
    >
      {{t 'task.actions.shift-month'}}
    </@dropdown.Item>

    {{#unless @shouldHideShiftOther}}
      <@dropdown.Item
        @onClick={{transitionToForc
          'task'
          'edition-form'
          patient=@task.patient
          sourceJeId=@task.id
        }}
        @key='shift-other'
      >
        {{t 'task.actions.shift-other'}}
      </@dropdown.Item>
    {{/unless}}
  </template>
}
